import React from 'react'

const IconBoxEdit = ({ fill = '#686867' }) => {
  return (
    <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_17697_30114'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='21'
        height='21'
      >
        <rect x='0.5' y='0.5' width='20' height='20' fill={fill} />
      </mask>
      <g mask='url(#mask0_17697_30114)'>
        <path
          d='M4.25776 18.0829C3.88262 18.0829 3.56554 17.9534 3.30651 17.6943C3.04748 17.4353 2.91797 17.1182 2.91797 16.7431V6.25599C2.91797 5.87516 3.04644 5.55321 3.30339 5.29016C3.56033 5.02696 3.87845 4.90231 4.25776 4.9162H11.2417L10.1584 5.99953H4.25776C4.19359 5.99953 4.13484 6.02627 4.08151 6.07974C4.02804 6.13307 4.0013 6.19182 4.0013 6.25599V16.7431C4.0013 16.8072 4.02804 16.866 4.08151 16.9193C4.13484 16.9728 4.19359 16.9995 4.25776 16.9995H14.7448C14.809 16.9995 14.8678 16.9728 14.9211 16.9193C14.9746 16.866 15.0013 16.8072 15.0013 16.7431V10.8104L16.0846 9.72703V16.7431C16.0846 17.1182 15.9551 17.4353 15.6961 17.6943C15.4371 17.9534 15.12 18.0829 14.7448 18.0829H4.25776ZM7.91797 13.0829V10.5764L15.1969 3.29766C15.3122 3.18224 15.4335 3.10182 15.5607 3.05641C15.6878 3.01099 15.821 2.98828 15.9605 2.98828C16.1017 2.98828 16.2376 3.01099 16.368 3.05641C16.4985 3.10182 16.6184 3.17807 16.7276 3.28516L17.6711 4.20786C17.7918 4.32328 17.8776 4.44981 17.9284 4.58745C17.9791 4.72509 18.0044 4.8646 18.0044 5.00599C18.0044 5.14766 17.9803 5.28481 17.9319 5.41745C17.8836 5.55009 17.802 5.67356 17.6871 5.78786L10.3842 13.0829H7.91797ZM9.0013 11.9995H9.93568L15.1086 6.82641L14.6519 6.34891L14.1584 5.8762L9.0013 11.0333V11.9995Z'
          fill={fill}
        />
      </g>
    </svg>
  )
}

export default IconBoxEdit
